// Базовая конфигурация окружения — порт из web/app-core.js (API_BASE, IS_DEV) и web/index.html.
// B1: база API кладётся инлайн-тегом в index.html (window.KQUANT_DEFAULT_API).

/** База API без хвостовых "/" (как в legacy api()). */
export const API_BASE = (window.KQUANT_DEFAULT_API || "").replace(/\/+$/, "");

/** Приложение всегда под /lab/ (vite base + Router basename). В legacy APP_BASE детектился из pathname. */
export const APP_BASENAME = "/lab";

/** dev-окружение: админка живёт только тут (бэк на проде отдаёт 404). Порт IS_DEV (app-core.js). */
export const IS_DEV =
  /(^|\.)dev\.kquant\.app$/i.test(location.hostname) ||
  /api-dev/i.test(API_BASE) ||
  location.hostname === "localhost" ||
  location.hostname === "127.0.0.1";
